import { DOCUMENT } from '@angular/common';
import { identity, map, pickBy } from 'lodash';
import { Meta, Title } from '@angular/platform-browser';
import { Subject, catchError, forkJoin, of, take } from 'rxjs';
import { Component, ChangeDetectorRef, Renderer2, Inject, PLATFORM_ID } from '@angular/core';

import { SlidesType } from '@sifca-monorepo/ecommerce-generator';

import { SharedService } from '../../services/shared.service';
import { SeoService, SlidesService, VisualsService } from '../../services';

@Component({
  template: '',
})
export class BaseIndexComponent {
  protected slides: SlidesType[] = [];

  seo: any;
  loading = true;
  posId: string = '';
  unsubscribeAll: Subject<any> = new Subject();

  constructor(
    protected renderer: Renderer2,
    protected metaTagService: Meta,
    protected titleTagService: Title,
    protected seoService: SeoService,
    protected sharedService: SharedService,
    protected slidesService: SlidesService,
    protected visualsService: VisualsService,
    protected changeDetectorRef: ChangeDetectorRef,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
      this.changeDetectorRef.markForCheck();
    });

    this.slidesService.slides$.subscribe((slides: SlidesType[]) => {
      if (slides) {
        this.slides = slides;
        this.handleSlides();
        this.changeDetectorRef.markForCheck();
      }
    });
    this.loading = false;

    this.seoService
      .getMainPageSEOJSON(this.posId)
      .pipe(
        take(1),
        catchError(() => of(null)),
      )
      .subscribe((res) => {
        this.seo = res;
        if (this.seo?.title) {
          this.titleTagService.setTitle(this.seo.title);
        }

        this.sharedService.tags$ = [...this.metaTagService.addTags(map(this.seo?.metas, (meta) => pickBy(meta, identity))), { charset: 'UTF-8' }];

        this.addSeoLinks();
        this.changeDetectorRef.markForCheck();
      });
  }

  protected addSeoLinks(): void {
    this.sharedService.links$ = map(this.seo.links, (seoLink) => {
      const link = this.renderer.createElement('link');
      if (seoLink.sizes) {
        link.sizes = seoLink.sizes;
      }
      if (seoLink.href) {
        link.href = seoLink.href;
      }
      if (seoLink.rel) {
        link.rel = seoLink.rel;
      }
      this.renderer.appendChild(this.document.head, link);
      return link;
    });
  }

  protected loadData(): void {
    if (this.posId) {
      forkJoin([
        this.seoService.getSeo(this.posId),
        this.slidesService.getSlides(this.posId),
        this.visualsService.getVisuals(this.posId),
      ]).subscribe();
    }
  }

  protected handleSlides(): void {
    // To be implemented in derived components.
  }
}
